import React from 'react'
import styled from 'styled-components'

const FormTitleWrapper = styled.div`
  typography: h2;
`

const FormSubtitleWrapper = styled.div`
  typography: subtitle1;
`

export function FormTitle({children}: {children: React.ReactNode}) {
  return <FormTitleWrapper data-testid="form-title">{children}</FormTitleWrapper>
}

export function FormSubtitle({children}: {children: React.ReactNode}) {
  return <FormSubtitleWrapper data-testid="form-subtitle">{children}</FormSubtitleWrapper>
}
